import { render } from "./Hotels.vue?vue&type=template&id=1dce052a&scoped=true"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"

import "./Hotels.vue?vue&type=style&index=0&id=1dce052a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce052a"]])

export default __exports__